import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Header from '@/components/Header'
import Home from '@/components/Home'
import product from '@/components/product'
import ArticleDetails from '@/components/ArticleDetails'
import dieuKhoan from '@/components/dieuKhoan'
import reSetPassword from '@/components/reSetPassword'
import allGames from '@/components/allGames'
import news from '@/components/news'
import my from '@/components/my'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/news',
      name: 'news',
	  meta: {
	    requiresAuth: true // 添加此字段，标示进入这个路由需要登录，router.beforeEach有判断
	  },
      component: news
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/reSetPassword',
      name: 'reSetPassword',
      component: reSetPassword
    },
    {
      path: '/allGames',
      name: 'allGames',
      component: allGames
    },
    {
      path: '/ArticleDetails',
      name: 'ArticleDetails',
      component: ArticleDetails
    },
    {
      path: '/dieu-khoan',
      name: 'dieu-khoan',
      component: dieuKhoan
    },
    {
      path: '/Header',
      name: 'Header',
      component: Header
    },
	{
	  path: '/my',
	  name: 'my',
	  component: my
	},
  ],
  mode: 'history'
})
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (store.state.token) {
      // console.log(store.state.token + '+' + store.state.userInfo);
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js